import React, { useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useForm, useWatch } from 'react-hook-form';
import { AppDispatch, RootState } from '@reducers/index';
import { emailChecker, passwordChecker } from '@utils/common/validators';
import { useNavigate } from 'react-router-dom';
import { axiosDummyInstance } from '@utils/axios/axiosInstance';
import { ILogInForm, LogInType } from '@models/auth/authModel';
import StepProgressiveBar from '@components/molecule/auth/stepProgressiveBar';

// 가입 뎁스1 (내부/외부 공용)
// 1 가입 폼
// 2 이메일은 요청 컴포넌트
const SignUp = () => {
  const navigate = useNavigate();

  const [isPasswordHide, setIsPasswordHide] = useState(true);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    getValues,
    setValue,
    watch,
  } = useForm<ILogInForm>({
    defaultValues: {
      email: '',
      password: '',
    },
  });

  // submit handler
  // TODO: aix 로직
  // 1. 현재 생성된 이메일인지 확인 -> 성공시 3번으로 넘어가기
  // 2. 이미 생성된 이메일이면 에러처리
  // 3. 성공시 emailConfirm 에 이멜 정보 넣고 해당 컴포넌트 모달 키기!
  //    (뒤로가기 처리 없애기!! ) - 아래와 같이 redirect 처리하여 뒤로가기 없앰!
  // navigate(targetPath, { replace: true }); // redirect!!!
  const onSubmit = useCallback(
    async (formObj: ILogInForm) => {
      try {
        const { data, status, statusText } = await axiosDummyInstance.get('/api/commonGetResponse.json', {
          params: formObj,
        });
        // 성공 시
        if (status == 200) {
          // 이미 생성된 일일때 아닐때 분기처리
          console.log('data: ', data);
          //@ts-ignore
          if (data.data === 'OK') {
            // 초기화 처리
            setValue('email', '');
            setValue('password', '');

            // 해당 주소로 옮기기
            navigate('/signupvarification', { replace: true, state: { email: 'test@aix.com' } });

            // @ts-ignore
          } else if (data.message === 'EMAIL_ERROR') {
            setError('email', { message: 'email already exist' }, { shouldFocus: true });
          }
        } else {
          throw new Error(statusText);
        }
      } catch (error) {
        console.log('error: ', error);
      }
    },
    [navigate]
  );

  //onClick SNS login handler
  // TODO: SNS 로직
  // 1. SNS 버튼 클릭 시 토큰을 받는다.
  // 2. 토큰을 queryString으로 해서 폼페이지로 넘겨준다. (이것도 뒤로가기 금지처리 할 것!)
  // 3, 2번으로 간 페이지에서 서버에 다시 요청하여 email을 가져옮!
  const onClickSNSLogIn = useCallback(
    async (type: LogInType.facebook | LogInType.google) => {
      try {
        const { data, status, statusText } = await axiosDummyInstance.get('/api/commonGetResponse.json', {
          params: { type },
        });
        if (status === 200 || status === 201) {
          // 받은 데이터를 쿼리스트링으로 넘김처리..
          return navigate(`/signupform`, { replace: true, state: { token: data.data, type: type } });
        } else {
          throw new Error(statusText);
        }
      } catch (error) {
        console.log('error: ', error);
        alert(`${error} error occur`);
      }
    },
    [navigate]
  );

  const onClickLogIn = useCallback(() => {
    navigate('/login');
  }, [navigate]);

  // 비번 보이기 처리
  const onChangePasswordHide = useCallback(() => {
    setIsPasswordHide((prev) => !prev);
  }, []);

  return (
    <div className="other-layout join">
      <div className="main-content">
        <header className="header">
          <div className="header-inner">
            <h1 className="header-logo">
              <img src="/images/logo-axo-app.png" alt="axo" />
            </h1>

            <label className="select type-1">
              <select>
                <option>ENG</option>
                <option>JP</option>
                <option>KOR</option>
              </select>
            </label>
          </div>
        </header>
        <div className="container">
          <div>
            <div className="manager">
              <div>
                <StepProgressiveBar step="step1" />
              </div>
              <h2 className="manager-tit">Welcome to axo</h2>
              <p className="manager-dsc">Free membership registration.</p>
            </div>

            <p className="join-member-txt">Please enter your email address to receive the membership link.</p>
            <div className="join-btn">
              <button type="button" className="btn-ico-single google" onClick={() => onClickSNSLogIn(LogInType.google)}>
                <span className="blind">구글 계정으로 회원가입</span>
              </button>
              <button
                type="button"
                className="btn-ico-single facebook"
                onClick={() => onClickSNSLogIn(LogInType.facebook)}
              >
                <span className="blind">페이스북 계정으로 회원가입</span>
              </button>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="form-ipt">
                <div className="form-ipt-tit">E-Mail</div>
                <label className="ipt">
                  <input
                    type="text"
                    placeholder="Enter your email address"
                    className={`${errors?.email ? 'error' : ''}`}
                    {...register('email', {
                      required: 'email is required',
                      validate: {
                        emailFormChecker: (value) => (emailChecker(value) ? true : 'email form is invalid'),
                      },
                    })}
                  />
                  {errors?.email && <span className="error-txt">{errors.email?.message}</span>}
                </label>

                <div className="form-ipt-tit">Password</div>
                <div className="ipt pw">
                  <label>
                    <input
                      type={`${isPasswordHide ? 'password' : 'text'}`}
                      className={`${errors?.password ? 'error' : ''}`}
                      placeholder="비밀번호 8~20글자, 알파벳, 숫자 혼합"
                      {...register('password', {
                        required: 'password is required',
                        validate: {
                          passwordFormCheck: (value) => (passwordChecker(value) ? true : 'password form is invalid'),
                        },
                      })}
                    />
                    {errors?.password && <span className="error-txt">{errors.password?.message}</span>}
                  </label>
                  <div className="pw-show-hide">
                    <input
                      type="checkbox"
                      className="ipt-check eyes"
                      id="checked-1"
                      checked={isPasswordHide}
                      onChange={onChangePasswordHide}
                    />
                    <label htmlFor="checked-1">
                      <span className="blind">감추기</span>
                    </label>
                  </div>
                </div>
              </div>

              <div className="join-btn-create">
                <button
                  type="submit"
                  className={`btn-b ${
                    watch().email.trim().length > 0 && watch().password.trim().length > 0 ? 'pri' : ''
                  }`}
                >
                  Create an account
                </button>
              </div>
            </form>

            <span className="join-or">or</span>
            <p className="join-login">
              Already registered?{' '}
              <button type="button" onClick={onClickLogIn}>
                Log In{' '}
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
